import React from 'react';
import { useParams } from 'react-router-dom';  

import HiddenGemsKerala from './category/travel/hidden-gems-kerala/hidden-gems-kerala';
import ManaliBlogPage from './category/travel/must-visit-places-manali/must-visit-places-manali';
import SpitiBlogPage from './category/travel/Spiti Valley/Spiti-Valley';
import MathuraVrindavanTravelGuide from './category/travel/mathura-vrindavan-travel-guide/mathura-vrindavan-travel-guide';

import LondonAfterDark from './category/Travelinternational/london-after-dark/london-after-dark';
import ThailandBlogCard from './category/Travelinternational/thailand-tropical-escape/thailand-tropical-escape';
import JapanCherryBlossom from './category/Travelinternational/japan-cherry-blossom-trails/japan-cherry-blossom-trails';
import DubaiLuxuryAdventure from './category/Travelinternational/dubai-luxury-adventure/dubai-luxury-adventure';
import VietnamBlog from './category/Travelinternational/vietnam-discovery/vietnam-discovery';

// import BaliBlogCard from './category/Travelinternational/bali-island-paradise/BaliBlogCard';



const blogComponents = {
  // 'category/ID' = Componentname
  'travel/hidden-gems-kerala': HiddenGemsKerala,
  'travel/must-visit-places-manali': ManaliBlogPage,
  'travel/spiti-valley-travel-story': SpitiBlogPage,
    'travel/mathura-vrindavan-travel-guide': MathuraVrindavanTravelGuide,
    
  'Travelinternational/london-after-dark':LondonAfterDark,
  'Travelinternational/thailand-tropical-escape':ThailandBlogCard,
    'Travelinternational/japan-cherry-blossom-trails':JapanCherryBlossom,
      'Travelinternational/dubai-luxury-adventure':DubaiLuxuryAdventure,
        'Travelinternational/vietnam-discovery':VietnamBlog,



  
  // 'Travelinternational/bali-island-paradise':BaliBlogCard

};

export default function SingleBlog() {
  const { category, blogId } = useParams(); 
  const key = `${category}/${blogId}`;
  const BlogComponent = blogComponents[key];

  if (!BlogComponent) return <p>Blog not found</p>;

  return <BlogComponent />; 
}
